import { useRef, useState, useEffect } from 'react'

export const useRecommendationFloatingCta = ({
  enabled,
}: {
  enabled: boolean
}) => {
  const staticPriceListRef = useRef(null)
  const [shouldShowCta, setShouldShowCta] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const isAboveViewport =
          !entry.isIntersecting && entry.boundingClientRect.top < 0
        setShouldShowCta(isAboveViewport)
      },
      { threshold: 0.7 },
    )

    const current = staticPriceListRef.current

    if (current) {
      observer.observe(current)
    }

    return () => {
      if (current) observer.unobserve(current)
    }
  }, [enabled])

  return { staticPriceListRef, shouldShowCta }
}
